module.exports = __webpack_public_path__ + "static/media/cand_mamilo_escuro.859f665b.png";